import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Cancel01Icon, Delete02Icon } from "../../assets/icons";
import CommomButton from "../commonButton";

export default function DeletePopup({
  icon,
  show,
  onHide,
  title,
  content,
  onConfirm,
  saveTitle,
  removeTitle,
  disabled,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setIsSubmitting(false);
    }
  }, [show]);

  useEffect(() => {
    if (!disabled) {
      setIsSubmitting(false);
    }
  }, [disabled]);

  const handleSave = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    onConfirm();
  };
  return (
    <Modal
      show={show}
      centered
      className="delete-modal"
    >
      <Modal.Header className="flex-column gap-3">
          <Delete02Icon size={48} className="primary" />
        <Modal.Title >
          {title || "Confirm Delete?"}
        </Modal.Title>
        <button
          className="close-btn"
          onClick={onHide}
        >
          <Cancel01Icon />
        </button>
      </Modal.Header>
      <Modal.Body className="text-center pt-0">
        {content}
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-top-0">
        {/* The safe choice needs to be visible. `removeTitle` was already being
            passed by callers and silently ignored — only the corner X let
            someone back out of a destructive action. */}
        {removeTitle && (
          <CommomButton
            disabled={isSubmitting}
            onClick={onHide}
            title={removeTitle}
            className="btn-secondary"
          />
        )}
        <CommomButton
          disabled={disabled || isSubmitting}
          isLoading={isSubmitting}
          onClick={handleSave}
          title={saveTitle}
          className="btn-primary"
        />
      </Modal.Footer>
    </Modal>
  );
}
